import { Button, ButtonVariant, StyledFlex } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { StyledRecordingDot } from './RecordButton.styled';

type RecordButtonProps = {
   recording: boolean;
   disabled?: boolean;
   onClick: VoidFunction;
};

export const RecordButton = (props: RecordButtonProps): JSX.Element => {
   const translate = useTranslate();

   const label = props.recording ? translationKeys.panel.recordButtonStop : translationKeys.panel.recordButtonStart;

   const content = props.recording ? (
      <StyledFlex alignItems={'center'} gap={'8px'} as={'span'}>
         <StyledRecordingDot aria-hidden='true' />
         {translate(label)}
      </StyledFlex>
   ) : (
      label
   );

   return (
      <Button
         testId={'recordButton'}
         label={content}
         onClick={props.onClick}
         disabled={props.disabled}
         variant={ButtonVariant.PRIMARY}
         fullLength
      />
   );
};
